module.exports = __webpack_public_path__ + "static/media/chairman.d06abf6d.jpg";